import { render, staticRenderFns } from "./roleBindTable.vue?vue&type=template&id=2d624345&scoped=true"
import script from "./roleBindTable.vue?vue&type=script&lang=js"
export * from "./roleBindTable.vue?vue&type=script&lang=js"
import style0 from "./roleBindTable.vue?vue&type=style&index=0&id=2d624345&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d624345",
  null
  
)

export default component.exports